//import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
//import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
NormalLoginoken: any;
  URLAttemptedToken: any;
constructor( private router: Router, private authService: AuthenticationService) { }
canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):| Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree {
    const user = this.authService.userValue;
    var ok:any;
    this.URLAttemptedToken = sessionStorage.getItem('loginURLAttempted');
    this.NormalLoginoken = sessionStorage.getItem('loginAttempted');
     // if(this.authService.userValue){
     if(this.NormalLoginoken == "true"){
    if (user) {
       // logged in so return true
      return true;
      
      //       if (!isLoggedIn) {
      //         // // Should Redirect Sig-In Page OR call refresh token API to continue
      //         //    this.authService.refreshToken().pipe().subscribe(data=>{
      //         //   ok=data
      //         //   if(ok){
      //         //    // this.router.navigate([state.url])
      //         //     return true
      //         //   }
      //         // });
             
      //       }
            // else{
            //   return true;
            // }
    //   const isLoggedIn=this.authService.isTokenExpired();
    //   if (isLoggedIn) {
    //     user.accessToken=""
    //     // Should Redirect Sig-In Page OR call refresh token API to continue
    //  this.authService.refreshToken().pipe().subscribe( data => {
    //    const ok=data
    //    if(ok){
    //    user.accessToken=ok.accessToken;
    //   // this.router.navigate(['/dashboard/personal-info'],{ queryParams: { returnUrl: state.url } });
    //   //  return true;
    //    }
    // });
    //  return true;
    //  }
      // logged in so return true
    //  return true;
    } else {
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
  }
  else{
    return true;
  }
}
}
